(function(){
"use strict";
const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
const esc=s=>String(s==null?"":s).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
const fmt=c=>{const f=(window.KB&&KB.money)||"${{amount}} MXN";const n=c/100;
  return f.replace(/\{\{\s*(\w+)\s*\}\}/,(m,k)=>k.indexOf("no_decimals")>-1?Math.round(n).toLocaleString("es-MX"):n.toLocaleString("es-MX",{minimumFractionDigits:2,maximumFractionDigits:2}))};

/* canasta */
function setCount(n){$$("[data-cart-count]").forEach(b=>b.textContent=n)}
async function addToCart(items){
  const r=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({items})});
  if(!r.ok){const e=await r.json().catch(()=>({}));throw new Error(e.description||"No se pudo agregar")}
  const c=await (await fetch("/cart.js")).json(); setCount(c.item_count); return c;
}
function flash(btn,txt,back){btn.classList.add("done");btn.textContent=txt;setTimeout(()=>{btn.classList.remove("done");btn.textContent=back},1500)}
document.addEventListener("submit",async e=>{
  const f=e.target.closest("[data-add-form]"); if(!f)return;
  e.preventDefault(); const btn=$(".add",f); if(!btn||btn.disabled)return;
  const id=+f.elements.id.value, q=+(f.elements.quantity&&f.elements.quantity.value||1);
  try{await addToCart([{id,quantity:q}]);flash(btn,"En tu canasta","Agregar a la canasta")}
  catch(err){flash(btn,"Sin existencias suficientes","Agregar a la canasta")}
});

/* variantes, cantidad, galería */
document.addEventListener("click",e=>{
  const vb=e.target.closest("[data-variant]");
  if(vb){const f=vb.closest("form");f.elements.id.value=vb.dataset.variant;
    $$("[data-variant]",f).forEach(b=>b.setAttribute("aria-pressed",b===vb));
    const scope=vb.closest("[data-product]")||f; const pr=$("[data-price]",scope); if(pr)pr.textContent=vb.dataset.price;
    if(vb.dataset.img){const im=$(".main-img",scope);if(im){im.removeAttribute("srcset");im.src=vb.dataset.img}}
    return}
  const q=e.target.closest("[data-q]");
  if(q){const f=q.closest("form"),inp=f.elements.quantity,n=Math.max(1,+inp.value+ +q.dataset.q);inp.value=n;$("[data-qty]",f).textContent=n;return}
  const th=e.target.closest("[data-thumb]");
  if(th){const g=th.closest(".gallery"),im=$(".main-img",g);if(im){im.removeAttribute("srcset");im.src=th.dataset.thumb}$$("[data-thumb]",g).forEach(b=>b.toggleAttribute("aria-current",b===th));return}
});

/* marcas */
const bbtn=$("#brandbtn"),bmenu=$("#brandmenu");
if(bbtn&&bmenu){const set=o=>{bmenu.hidden=!o;bbtn.setAttribute("aria-expanded",o)};
  bbtn.addEventListener("click",e=>{e.stopPropagation();set(bmenu.hidden)});
  document.addEventListener("click",e=>{if(!bmenu.hidden&&!e.target.closest("#brandmenu"))set(false)});
  document.addEventListener("keydown",e=>{if(e.key==="Escape"&&!bmenu.hidden){set(false);bbtn.focus()}});}

/* galería de inicio */
$$("[data-slider]").forEach(sl=>{
  const imgs=$$(".slides img",sl),dots=$("[data-dots]",sl); if(imgs.length<2){if(dots)dots.remove();return}
  dots.innerHTML=imgs.map((_,i)=>`<button type="button" aria-label="Foto ${i+1}" data-dot="${i}"></button>`).join("");
  let k=0,t=null;const ms=(+sl.dataset.speed||5)*1000,reduce=matchMedia("(prefers-reduced-motion: reduce)").matches;
  const go=i=>{k=(i+imgs.length)%imgs.length;imgs.forEach((im,j)=>im.classList.toggle("on",j===k));$$("button",dots).forEach((b,j)=>b.toggleAttribute("aria-current",j===k))};
  const start=()=>{if(!reduce){clearInterval(t);t=setInterval(()=>go(k+1),ms)}};
  dots.addEventListener("click",e=>{const b=e.target.closest("[data-dot]");if(b){go(+b.dataset.dot);start()}});
  sl.addEventListener("mouseenter",()=>clearInterval(t));sl.addEventListener("mouseleave",start);
  go(0);start();
});

/* filtros */
const ff=$("[data-filter-form]");
if(ff){
  let tm;ff.addEventListener("change",e=>{if(e.target.type==="number"){clearTimeout(tm);tm=setTimeout(()=>ff.requestSubmit(),600)}else ff.requestSubmit()});
  ff.addEventListener("submit",()=>{$$("input",ff).forEach(i=>{if(i.type==="number"&&i.value==="")i.disabled=true})});
  const fl=$("[data-filters]"),sc=$("[data-scrim]"),open=o=>{fl.classList.toggle("open",o);sc.classList.toggle("open",o)};
  const ob=$("[data-openf]");if(ob)ob.addEventListener("click",()=>open(true));
  const cb=$("[data-closef]");if(cb)cb.addEventListener("click",()=>open(false));
  if(sc)sc.addEventListener("click",()=>open(false));
}
const so=$("[data-sort]");
if(so)so.addEventListener("change",()=>{const u=new URL(location.href);u.searchParams.set("sort_by",so.value);u.searchParams.delete("page");location.href=u.toString()});

/* también te puede gustar */
$$("[data-recs]").forEach(async el=>{
  try{const r=await fetch(el.dataset.recs);const h=await r.text();const d=new DOMParser().parseFromString(h,"text/html");
    const s=d.querySelector(".shopify-section")||d.body;el.innerHTML=s.innerHTML;if(!el.textContent.trim())el.remove()}catch(_){el.remove()}
});

/* arma tu rutina */
const qel=$("[data-quiz]"); if(!qel)return;
let P=[];try{P=JSON.parse($("[data-quiz-products]").textContent)}catch(_){}
P.forEach((d,i)=>{d.i=i;d.tags=Array.isArray(d.tags)?d.tags:String(d.tags||"").split(/,\s*/);
  d.sk=d.tags.filter(t=>t.indexOf("piel:")===0).map(t=>t.slice(5));
  d.nd=d.tags.filter(t=>t.indexOf("necesidad:")===0).map(t=>t.slice(10));
  d.preg=d.tags.includes("advertencia-embarazo");d.skip=d.tags.includes("sin-cuestionario")});
const QS=[
 {k:"skin",ask:"¿Cómo se siente tu piel un par de horas después de lavarla?",opts:[
   ["Grasa","Brillosa en toda la cara"],["Mixta","Brillosa en la zona T, normal o seca en mejillas"],["Seca","Tirante o con resequedad"],["Normal","Cómoda, ni grasa ni seca"]]},
 {k:"sens",ask:"¿Tu piel se irrita o se pone roja con facilidad?",opts:[["Sí","Me pasa seguido"],["A veces","Con algunos productos o con el clima"],["Casi nunca","Aguanta casi todo"]]},
 {k:"needs",multi:2,ask:"¿Qué te gustaría mejorar?",hint:"Elige hasta dos.",opts:[
   ["Acné","Granitos y brotes"],["Manchas","Manchas, marcas de acné o tono disparejo"],["Oleosidad","Brillo y poros visibles"],["Hidratación","Resequedad o falta de glow"],["Antiedad","Líneas finas y firmeza"],["Calmante","Rojez e irritación"]]},
 {k:"steps",ask:"¿Cuántos pasos quieres en tu rutina?",opts:[["Básica","3 pasos: limpiador, crema y protector solar"],["Completa","5 pasos: suma tónico y sérum"],["K-Beauty completa","8 pasos: con doble limpieza, exfoliante y contorno de ojos"]]},
 {k:"preg",ask:"¿Estás embarazada o en lactancia?",hint:"Así dejamos fuera los productos que no se recomiendan en esta etapa.",opts:[["Sí",""],["No",""]]}
];
const STEP={"Limpiadores en Aceite":["Limpiador en aceite","Noche, primer paso de la doble limpieza"],"Limpiadores":["Limpiador","Mañana y noche"],"Exfoliantes":["Exfoliante","1 o 2 veces por semana"],"Tónicos":["Tónico","Mañana y noche"],"Sérums":["Sérum","Mañana y noche"],"Contornos de Ojos":["Contorno de ojos","Mañana y noche"],"Cremas Hidratantes":["Crema hidratante","Mañana y noche"],"Protectores Solares":["Protector solar","Todas las mañanas, último paso"]};
const ROUT={"Básica":["Limpiadores","Cremas Hidratantes","Protectores Solares"],"Completa":["Limpiadores","Tónicos","Sérums","Cremas Hidratantes","Protectores Solares"],"K-Beauty completa":["Limpiadores en Aceite","Limpiadores","Exfoliantes","Tónicos","Sérums","Contornos de Ojos","Cremas Hidratantes","Protectores Solares"]};
const qz={step:-1,a:{needs:[]},alt:{}};
function pick(cat){const a=qz.a,sens=a.sens==="Sí"?2:a.sens==="A veces"?1:0;
  return P.filter(d=>d.c===cat&&!d.skip&&!(a.preg==="Sí"&&d.preg)).map(d=>{let s=0;
    if(d.sk.includes(a.skin))s+=3;else if(d.sk.includes("Todo tipo de piel"))s+=2;
    if(sens&&d.sk.includes("Sensible"))s+=sens; if(sens&&d.nd.includes("Calmante"))s+=sens;
    a.needs.forEach(n=>{if(d.nd.includes(n))s+=3});return[s,d]}).sort((x,y)=>y[0]-x[0]||x[1].i-y[1].i).map(x=>x[1])}
function media(d){return d.img?`<div class="ph"><img src="${esc(d.img)}" alt="" loading="lazy"></div>`:`<div class="ph" data-shape="bottle" style="--tone:#F3A0AA;--ink:#530F0E"><div class="v"><i>${esc(d.b)}</i></div></div>`}
function draw(){
  if(qz.step<0){qel.innerHTML=`<div class="q-intro"><h1 class="rt">${esc(qel.dataset.title)}</h1><p>${esc(qel.dataset.intro)}</p><button type="button" class="q-btn" data-qgo="0">${esc(qel.dataset.start)}</button></div>`;return}
  if(qz.step>=QS.length)return result();
  const q=QS[qz.step],v=qz.a[q.k],sel=o=>q.multi?v.includes(o):v===o,ok=q.multi?v.length>0:v!=null;
  qel.innerHTML=`<div class="q-prog"><span>Pregunta ${qz.step+1} de ${QS.length}</span><div class="q-bar"><i style="width:${(qz.step+1)/QS.length*100}%"></i></div></div>
  <h1 class="q-ask">${q.ask}</h1>${q.hint?`<p class="q-hint">${q.hint}</p>`:""}
  <div class="q-opts" role="group">${q.opts.map(([o,s])=>`<button type="button" class="q-opt" data-qo="${esc(o)}" aria-pressed="${sel(o)}"><b>${esc(o)}</b>${s?`<small>${esc(s)}</small>`:""}</button>`).join("")}</div>
  <div class="q-nav"><button type="button" class="q-btn ghost" data-qgo="${qz.step-1}">Atrás</button><button type="button" class="q-btn" data-qgo="${qz.step+1}" ${ok?"":"disabled"}>${qz.step===QS.length-1?"Ver mi rutina":"Siguiente"}</button></div>`;
}
let rows=[];
function result(){
  const a=qz.a;rows=ROUT[a.steps].map(c=>{const l=pick(c);return l.length?[c,l[(qz.alt[c]||0)%l.length],l.length]:null}).filter(Boolean);
  const total=rows.reduce((s,[,d])=>s+d.p,0);
  qel.innerHTML=`<h1 class="rt">Tu rutina</h1>
  <div class="q-sum"><span>Piel ${esc(a.skin.toLowerCase())}</span>${a.sens!=="Casi nunca"?"<span>Sensible</span>":""}${a.needs.map(n=>`<span>${esc(n)}</span>`).join("")}<span>Rutina ${esc(a.steps.toLowerCase())}</span></div>
  <ol class="q-steps">${rows.map(([c,d,n])=>`<li class="q-step"><a class="plink" href="${esc(d.u)}" aria-label="${esc(d.t)}">${media(d)}</a>
    <div class="info"><span class="kind">${STEP[c][0]}</span><span class="when">${STEP[c][1]}</span><span class="brand">${esc(d.b)}</span>
    <h3><a href="${esc(d.u)}">${esc(d.t)}</a></h3>
    <form class="row" data-add-form><input type="hidden" name="id" value="${d.v}"><span class="price">${esc(d.pm)}</span><button class="add" type="submit">Agregar a la canasta</button>${n>1?`<button type="button" class="q-swap" data-qswap="${esc(c)}">Ver otra opción</button>`:""}</form></div></li>`).join("")}</ol>
  <div class="q-total"><div><span class="q-note">Total de la rutina</span><br><span class="price">${esc(fmt(total))}</span></div><button type="button" class="q-btn" data-qall>Agregar toda la rutina</button></div>
  ${a.preg==="Sí"?`<p class="q-note">Dejamos fuera los productos que no se recomiendan durante el embarazo o la lactancia.</p>`:""}
  <div class="q-nav"><button type="button" class="q-btn ghost" data-qgo="0" data-qreset>Volver a empezar</button><a class="q-btn ghost" href="/collections/all" style="text-decoration:none">Ver todo el catálogo</a></div>`;
}
qel.addEventListener("click",async e=>{
  const o=e.target.closest("[data-qo]");
  if(o){const q=QS[qz.step],v=o.dataset.qo;if(q.multi){const arr=qz.a[q.k],i=arr.indexOf(v);if(i>=0)arr.splice(i,1);else{arr.push(v);if(arr.length>q.multi)arr.shift()}}else qz.a[q.k]=v;draw();return}
  const g=e.target.closest("[data-qgo]");
  if(g&&!g.disabled){if(g.hasAttribute("data-qreset")){qz.a={needs:[]};qz.alt={}}qz.step=Math.max(-1,+g.dataset.qgo);draw();qel.scrollIntoView({block:"start"});return}
  const s=e.target.closest("[data-qswap]");if(s){const c=s.dataset.qswap;qz.alt[c]=(qz.alt[c]||0)+1;result();return}
  const all=e.target.closest("[data-qall]");
  if(all){try{await addToCart(rows.map(([,d])=>({id:d.v,quantity:1})));all.textContent="Rutina en tu canasta"}catch(_){all.textContent="Revisa existencias"}setTimeout(()=>all.textContent="Agregar toda la rutina",1600)}
});
draw();
})();
(() => {
  const setupCategoryMenus = () => {
    document.querySelectorAll("[data-category-toggle]").forEach(button => {
      if (button.dataset.categoryReady) return;

      const panel = document.getElementById(
        button.getAttribute("aria-controls")
      );
      if (!panel) return;
      button.dataset.categoryReady = "true";

      const close = () => {
        panel.hidden = true;
        button.setAttribute("aria-expanded", "false");
      };

      button.addEventListener("click", () => {
        const opening = panel.hidden;

        document.querySelectorAll("[data-category-toggle]").forEach(other => {
          const otherPanel = document.getElementById(
            other.getAttribute("aria-controls")
          );
          other.setAttribute("aria-expanded", "false");
          if (otherPanel) otherPanel.hidden = true;
        });

        panel.hidden = !opening;
        button.setAttribute("aria-expanded", String(opening));
      });

      document.addEventListener("click", event => {
        if (!button.contains(event.target) &&
            !panel.contains(event.target)) close();
      });

      document.addEventListener("keydown", event => {
        if (event.key === "Escape" && !panel.hidden) {
          close();
          button.focus();
        }
      });

      document.addEventListener("focusin", event => {
        if (!button.contains(event.target) &&
            !panel.contains(event.target)) close();
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupCategoryMenus);
  } else {
    setupCategoryMenus();
  }

  document.addEventListener("shopify:section:load", setupCategoryMenus);
})();
(() => {
  function setupPredictiveSearch() {
    document.querySelectorAll(".header-search").forEach(form => {
      if (form.dataset.predictiveReady) return;

      const input = form.querySelector('input[name="q"]');
      const panel = form.querySelector("[data-search-suggestions]");
      const status = form.querySelector("[data-search-status]");
      const list = form.querySelector("[data-search-results]");
      if (!input || !panel || !status || !list) return;

      form.dataset.predictiveReady = "true";
      input.setAttribute("autocomplete", "off");

      let timer;
      let controller;
      let revision = 0;

      const close = () => {
        clearTimeout(timer);
        revision += 1;
        controller?.abort();
        panel.hidden = true;
      };

      input.addEventListener("input", () => {
        close();
        list.replaceChildren();

        const term = input.value.trim();
        if (term.length < 2) return;

        const currentRevision = revision;

        timer = setTimeout(async () => {
          controller = new AbortController();
          status.textContent = "Buscando productos…";
          panel.hidden = false;

          try {
            const root = window.Shopify?.routes?.root || "/";
            const url = new URL(
              `${root}search/suggest.json`,
              window.location.origin
            );

            url.searchParams.set("q", term);
            url.searchParams.set("resources[type]", "product");
            url.searchParams.set("resources[limit]", "5");

            const response = await fetch(url, {
              signal: controller.signal
            });
            if (!response.ok) throw new Error("Search failed");

            const data = await response.json();
            if (currentRevision !== revision) return;

            const products = data.resources?.results?.products;
            if (!Array.isArray(products)) {
              throw new Error("Invalid response");
            }

            list.replaceChildren();

            products.forEach(product => {
              const destination = new URL(
                product.url,
                window.location.origin
              );
              if (destination.origin !== window.location.origin) return;

              const item = document.createElement("li");
const link = document.createElement("a");
link.href = destination.href;

const imageSource =
  product.featured_image?.url ||
  (typeof product.image === "string"
    ? product.image
    : product.image?.url);

if (imageSource) {
  const image = document.createElement("img");
  image.src = imageSource;
  image.alt = "";
  image.width = 52;
  image.height = 52;
  image.loading = "lazy";
  image.className = "search-product-image";
  image.addEventListener("error", () => image.remove(), {
    once: true
  });
  link.append(image);
}

const title = document.createElement("span");
title.textContent = product.title;
link.append(title);

item.append(link);
list.append(item);

            });

            status.textContent = products.length
              ? "Productos sugeridos"
              : "Sin sugerencias. Pulsa Buscar para ver los resultados.";
          } catch (error) {
            if (error.name !== "AbortError" &&
                currentRevision === revision) {
              status.textContent =
                "Pulsa Buscar para ver los resultados.";
            }
          }
        }, 250);
      });

      form.addEventListener("keydown", event => {
        if (event.key === "Escape") {
          close();
          input.focus();
          return;
        }

        if (panel.hidden) return;

        const links = [...list.querySelectorAll("a")];
        if (!links.length) return;

        if (event.key === "ArrowDown") {
          event.preventDefault();
          const index = links.indexOf(document.activeElement);
          links[(index + 1) % links.length].focus();
        }

        if (event.key === "ArrowUp") {
          event.preventDefault();
          const index = links.indexOf(document.activeElement);
          if (index <= 0) input.focus();
          else links[index - 1].focus();
        }
      });

      document.addEventListener("click", event => {
        if (!form.contains(event.target)) close();
      });

      form.addEventListener("focusout", () => {
        setTimeout(() => {
          if (!form.contains(document.activeElement)) close();
        }, 0);
      });

      form.addEventListener("submit", close);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupPredictiveSearch);
  } else {
    setupPredictiveSearch();
  }

  document.addEventListener("shopify:section:load", setupPredictiveSearch);
})();
